<template>
  <div class="base-info">
    <a-card :bordered="false" title="可选版本" :headStyle="{paddingLeft:'0px'}">
      <div style="clear:both;" v-if="subOneList">
        <div style="float: left;width: 10%">
          <div class="wHigth" style="font-size: 16px;font-weight: bold">功能权益</div>
          <!--          <div class="wHigth">&nbsp;</div>-->
          <div v-for="i in subOneList">
            <div class="wHigth">{{ i.permissionsName }}</div>
          </div>
          <!--          <div class="wHigth wHigth2">&nbsp;</div>-->
        </div>
        <div style="float: left;width: 30%">
          <div class="wHigth" style="font-size: 16px;font-weight: bold">功能介绍</div>
          <!--          <div class="wHigth">&nbsp;</div>-->
          <div v-for="i in subOneList">
            <div class="wHigth">{{ i.permissionsDes }}</div>
          </div>
          <!--          <div class="wHigth wHigth2">&nbsp;</div>-->
        </div>
        <div v-for="(k,idx) in subList" style="float: left;width: 20%">
          <div class="wHigth" style="font-size: 16px;font-weight: bold">{{ k.informationName }}</div>
          <!--          <div class="wHigth" style="color: red">{{k.informationAmount}}元/年</div>-->
          <div v-for="j in k.versionBasisVos" class="wHigth">
            <div v-if="idx == 2">
              <span><img src="https://imgb.woyoubooking.com/common/platform_select.png"/></span>
            </div>
            <div v-else>
              <span v-if="j.type"><img src="https://imgb.woyoubooking.com/common/platform_unSelect.png"/></span>
              <span v-else><img src="https://imgb.woyoubooking.com/common/platform_select.png"/></span>
            </div>
          </div>
          <!--            基础版 3 标准版4 高级版5 黄金版6 铂金版7 钻石版8-->
          <!--          <div v-if="info.informationId == 2" class="wHigth wHigth2">-->
          <!--            <a-button type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 3" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 3" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--            <a-button v-else type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 4" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 4" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--            <a-button v-else type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 5" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 5" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--            <a-button v-else type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 6" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 6" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--            <a-button v-else-if="k.informationId>6" type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 7" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 7" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--            <a-button v-else-if="k.informationId>7" type="danger" @click="submitPay(k)">立即升级</a-button>-->
          <!--          </div>-->
          <!--          <div v-if="info.informationId == 8" class="wHigth wHigth2">-->
          <!--            <a-button v-if="k.informationId == 8" type="primary" @click="submitPay(k)">马上续订</a-button>-->
          <!--          </div>-->
        </div>
      </div>
    </a-card>
    <a-modal title="选择支付" :visible="visible" @cancel="handleCancel" width="650px" :footer="null"
             :maskClosable='false'>
      <a-form-model :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="订购版本">
          {{ chooseInfo.informationName }}
        </a-form-model-item>
        <a-form-model-item label="">
          <div class="tabMian">
            <div class="tabLeft" :class="{'tabstyle':isActive==2}" @click="chooseYear(2)">
              <p>续费两年</p>
              <p>￥<i>{{ chooseInfo.informationAmount * 2 }}</i></p>
            </div>
            <div class="tabLeft" :class="{'tabstyle':isActive==1}" @click="chooseYear(1)">
              <p>续费一年</p>
              <p>￥<i>{{ chooseInfo.informationAmount }}</i></p>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="支付方式">
          <a-radio-group name="radioGroup" v-model="params.type" @change="radioChange">
            <a-radio :value="1">支付宝</a-radio>
            <a-radio :value="2">微信</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label=" " :colon="false" :required="false">
          <div class="bankInfoText2">
            <p>请{{ params.type == 1 ? '支付宝' : '微信' }}扫描下方二维码完成支付</p>
            <img :src="erWeiMaImageSrc"/>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'VersionUpgrade',
  data() {
    return {
      businessFileList: [],
      tabList: [], //
      subList: [],
      subOneList: {},
      subTabList: [],
      arr: [],
      noArr: [],
      info: '',
      visible: false,
      isActive: 2,
      money: '',
      chooseInfo: '',
      params: {
        type: 1
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      erWeiMaImageSrc: '',
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
        offsetCol: { offset: 5 }
      },
      randomNumber: '',
      timer: null
    }
  },
  mounted() {
    this.getQueryStaticDetails()
    this.getQueryUpgradeDetails()
    setTimeout(() => {
      this.cheack()
    }, 1000)
  },
  destroyed() {
    this.clearTimeout()
  },
  methods: {
    getQueryStaticDetails() {
      this.getHttpServices().getUserService().post('api/v2/versionInformation/queryStaticDetails')
        .then(res => {
          this.tabList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    cheack() {
      //基础版 3 标准版4 高级版5 黄金版6 铂金版7 钻石版8
      //subList 当前list   subOneList 当前list最大数据
      if (this.info.informationId == 3) {
        this.tabList.forEach(v => {
          if (v.informationId == 3 || v.informationId == 6 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      } else if (this.info.informationId == 4) {
        this.tabList.forEach(v => {
          if (v.informationId == 4 || v.informationId == 6 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      } else if (this.info.informationId == 5) {
        this.tabList.forEach(v => {
          if (v.informationId == 5 || v.informationId == 6 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      } else if (this.info.informationId == 6) {
        this.tabList.forEach(v => {
          if (v.informationId == 3 || v.informationId == 6 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      } else if (this.info.informationId == 7) {
        this.tabList.forEach(v => {
          if (v.informationId == 3 || v.informationId == 7 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      } else {
        this.tabList.forEach(v => {
          if (v.informationId == 3 || v.informationId == 7 || v.informationId == 8) {
            this.subList.push(v)
          }
          if (v.informationId == 8) {
            this.subOneList = v.versionBasisVos
          }
        })
      }
      this.subList.forEach(v => {
        this.subOneList.forEach((v2, k) => {
          let t = true
          v.versionBasisVos.forEach(v3 => {
            if (v2.permissionsName == v3.permissionsName && v2.permissionsType == v3.permissionsType) {
              t = false
            }
          })
          if (t) {
            v2.type = true
            v.versionBasisVos.splice(k, 0, v2)
          }
        })
      })

    },
    getQueryUpgradeDetails() {
      this.getHttpServices().getUserService().post('api/v2/versionInformation/queryDetails').then(res => {
        if (res) {
          this.info = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.visible = false
      this.clearTimeout()
    },
    submitPay(i) {
      this.visible = true
      this.chooseInfo = i
      this.params.type = 1
      this.isActive = 2
      this.money = i.informationAmount * 2
      this.getRandomNumber()
    },
    chooseYear(num) {
      this.isActive = num
      this.money = this.chooseInfo.informationAmount * num
      this.getCodeImg()
    },
    radioChange(value) {
      this.params.type = value.target.value
      this.getCodeImg()
    },
    getCodeImg() {
      console.log(this.money)
      const url = `service/rechargeVersionCodeImg/${this.params.type}/${this.merchantId}/${this.platformId}/${this.chooseInfo.informationId}/${this.money}/${this.isActive}/${this.randomNumber}`
      this.erWeiMaImageSrc = this.getAppConfig().serviceUrl + url
    },
    // 获取 生成随机数接口
    getRandomNumber() {
      this.getHttpServices().getServerApiService().get('service/generateRandomNumber/' + this.merchantId + '/' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('res-----data', res)
        if (res && res.randomNumber) {
          this.randomNumber = res.randomNumber
          this.getCodeImg()
          this.getTimer()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updatePayStatus() {
      const params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        randomNumber: this.randomNumber
      }
      this.getHttpServices().getServerApiService().post('service/versionPayUpgradeStatus', params).then(res => {
        this.getLogUtils().logWithTag('res-----data', res)
        if (res && res.payStatus) {
          this.handleCancel()
          this.$message.success('支付成功')
        }
      }).catch(reason => {
        this.getLogUtils().logWithTag('reason', reason)
      })
    },
    getTimer() {
      this.timer = setInterval(this.updatePayStatus, 1000)
    },
    clearTimeout() {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="less" scoped>
@import "./baseInfo";

.tabMian {
  .tabLeft {
    width: 200px;
    padding: 20px;
    position: relative;
    margin-left: 30px;
    border: 1px #eee solid;
    text-align: center;
    display: inline-block;
    cursor: pointer;

    p {
      font-size: 16px;
      margin-bottom: 0;
    }

    p:nth-child(2) {
      font-size: 14px;
      color: red;

      i {
        font-style: normal;
        font-size: 26px;
      }
    }

    p:nth-child(4) {
      font-size: 12px;
      line-height: 24px;
      background-color: #FEA834;
      color: #fff;
    }
  }

  .tabLeft.tabstyle {
    background-color: #ffeddf;
    border: 1px #ff7700 solid;
  }
}

.bankInfoText {
  p {
    line-height: 26px;
    margin-bottom: 0;
  }

  p:nth-child(1) {
    color: #000;
  }
}

.wHigth {
  height: 45px;
  text-align: center;
  display: flex;
  align-items: center;
  border-bottom: 1px #d6d6d6 solid;
  text-align: center;
  justify-content: center;

  img {
    width: 30px;
    height: 30px;
  }
}

.wHigth.wHigth2 {
  height: 70px;
}

.bankInfoText2 {
  p {
    margin-bottom: 0;
  }

  img {
    width: 200px;
    height: 200px;
  }
}

.content-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>